export enum MemberPropertyEnum {
  BOOLEAN_VALUE = 'booleanValue',
  NUMBER_VALUE = 'numberValue',
  STRING_VALUE = 'stringValue',
  JSON_VALUE = 'jsonValue',
  LIMITS_OVERRIDE = 'limitsOverride',
  RECENTLY_USED_TAGS = 'recentlyUsedTags',
  DECLINED_SUGGESTED_FOLLOW_STREAMS = 'declinedSuggestedFollowStreams',
}

export const memberProperties = {
  [MemberPropertyEnum.BOOLEAN_VALUE]: {
    defaultValue: false,
    type: Boolean,
  },
  [MemberPropertyEnum.NUMBER_VALUE]: {
    defaultValue: 0,
    type: Number,
  },
  [MemberPropertyEnum.STRING_VALUE]: {
    defaultValue: '',
    type: String,
  },
  [MemberPropertyEnum.JSON_VALUE]: {
    defaultValue: null,
    type: JSON,
  },
  [MemberPropertyEnum.LIMITS_OVERRIDE]: {
    defaultValue: {
      STARTER_FREE: {
        ADMIN: {
          TOTAL_VIDEOS: 25,
        },
      },
      CREATOR_LITE: {
        TOTAL_VIDEOS: 25,
        VIDEO_DURATION: 300,
      },
    },
    type: JSON,
  },
  // A user's recently used tags, stored in order from most recent to least recent.
  [MemberPropertyEnum.RECENTLY_USED_TAGS]: {
    defaultValue: [],
    type: JSON,
  },
  // A user's declined suggested streams to follow
  [MemberPropertyEnum.DECLINED_SUGGESTED_FOLLOW_STREAMS]: {
    defaultValue: [],
    type: JSON,
  },
};

type JsonType = {
  something: string;
  somethingElse: number;
  also?: boolean;
};

type LimitOverrideType = {
  STARTER_FREE: Record<string, any>;
  CREATOR_LITE: Record<string, any>;
};

type RecentlyUsedTagsType = string[];
type DeclinedSuggestedFollowStreamsType = { type: string; value: string }[];

export type MemberPropertyValueType<T> =
  T extends MemberPropertyEnum.BOOLEAN_VALUE
    ? boolean
    : T extends MemberPropertyEnum.NUMBER_VALUE
    ? number
    : T extends MemberPropertyEnum.STRING_VALUE
    ? string
    : T extends MemberPropertyEnum.JSON_VALUE
    ? JsonType
    : T extends MemberPropertyEnum.LIMITS_OVERRIDE
    ? LimitOverrideType
    : T extends MemberPropertyEnum.RECENTLY_USED_TAGS
    ? RecentlyUsedTagsType
    : T extends MemberPropertyEnum.DECLINED_SUGGESTED_FOLLOW_STREAMS
    ? DeclinedSuggestedFollowStreamsType
    : unknown;
